import m from "../../geodata/es2015/omanLow";
window.am4geodata_omanLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/omanLow.js
// module id = null
// module chunks = 